import { useTranslation } from 'react-i18next';
import { DEFAULT_LOGO_URL as logoUrl } from '../platform.tsx';
import { logout } from '../auth.tsx';
import { PasswordChangeForm } from '../components/PasswordForm.tsx';
import { SISTEMA_NOME } from '../sistema.ts';

/** Primeiro acesso com a senha provisória: a pessoa cria a própria senha antes de usar o sistema. */
export function ForcedPasswordChange() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh items-center justify-center px-4 py-10">
      <div className="flex w-full max-w-sm flex-col gap-6 rounded-lg border border-rule bg-sheet p-8 shadow-sm">
        <div className="flex flex-col gap-1">
          <img
            src={logoUrl}
            alt={SISTEMA_NOME}
            className="mb-3 max-h-16 w-auto max-w-40 object-contain object-left"
          />
          <h1 className="text-xl font-semibold">{t('password.firstTitle')}</h1>
          <p className="text-sm text-muted">{t('password.firstBody')}</p>
        </div>
        <PasswordChangeForm temporary />
        <button
          type="button"
          onClick={() => void logout()}
          className="self-start text-sm text-muted underline-offset-2 hover:text-ink hover:underline"
        >
          {t('auth.logout')}
        </button>
      </div>
    </div>
  );
}
